/**
 * Constants for the PropertyPanel component.
 */

/**
 * The width of the property panel in pixels.
 * Used consistently across property panel components.
 */
export const PROPERTY_PANEL_WIDTH = 400;

/**
 * Extra clearance used when shifting floating toolbars away from stacked panels.
 */
export const RIGHT_SIDE_PANEL_TOOLBAR_GAP = 4;
